<script setup>
import { computed } from "vue";
import dayjs from "dayjs";

const props = defineProps({ journey: { type: Object, required: true } });
const money = (value) =>
  value == null
    ? "Not provided"
    : new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
      }).format(Number(value));
const date = (value) =>
  value ? dayjs(value).format("ddd D MMM YYYY, HH:mm") : "Not provided";
const fields = computed(() => [
  ["Request ID", props.journey.external_request_id || "Not provided"],
  ["Group ID", props.journey.group_id || "Not provided"],
  ["Journey type", props.journey.journey_type || "Not provided"],
  ["Service", props.journey.service || "Not provided"],
  ["Mobility", props.journey.mobility || "Not provided"],
  ["Bid placed", date(props.journey.bid_at)],
  ["Bid placed by", props.journey.bid_by || "Not provided"],
  ["Bid hourly rate", money(props.journey.bid_hourly_rate)],
  ["Bid waiting rate / hour", money(props.journey.bid_waiting_hourly_rate)],
  [
    "Suggested hourly rate",
    money(props.journey.pricing_breakdown?.hourly_rate),
  ],
  [
    "Suggested waiting rate / hour",
    money(props.journey.pricing_breakdown?.waiting_hourly_rate),
  ],
  [
    "Distance",
    props.journey.pricing_breakdown?.distance_miles == null
      ? "Not provided"
      : `${props.journey.pricing_breakdown.distance_miles} miles`,
  ],
  ["Last checked", date(props.journey.last_seen_at)],
]);
</script>

<template>
  <div class="space-y-4">
    <dl class="grid gap-x-5 gap-y-3 text-sm sm:grid-cols-2 xl:grid-cols-3">
      <div v-for="[label, value] in fields" :key="label">
        <dt class="text-xs font-semibold text-slate-500">{{ label }}</dt>
        <dd class="mt-1 break-words text-slate-800 dark:text-slate-100">
          {{ value }}
        </dd>
      </div>
    </dl>
    <div class="rounded-lg bg-slate-50 p-3 dark:bg-slate-900/40">
      <h3 class="text-sm font-semibold text-slate-800 dark:text-slate-100">
        Booking details
      </h3>
      <ul
        v-if="journey.booking_details?.length"
        class="mt-2 space-y-2 text-sm text-slate-700 dark:text-slate-200"
      >
        <li
          v-for="(detail, index) in journey.booking_details"
          :key="index"
          class="whitespace-pre-line"
        >
          {{ detail }}
        </li>
      </ul>
      <p v-else class="mt-1 text-sm text-slate-500">
        Check for journeys to load full booking details.
      </p>
    </div>
    <dl
      v-if="journey.pricing_breakdown?.legs"
      class="grid gap-3 text-sm sm:grid-cols-3"
    >
      <div v-for="(leg, key) in journey.pricing_breakdown.legs" :key="key">
        <dt class="font-semibold text-slate-500">
          {{ key.replaceAll("_", " ") }}
        </dt>
        <dd class="mt-1 text-slate-700 dark:text-slate-200">
          {{ leg.origin }} → {{ leg.destination }}<br />{{
            leg.driving_minutes
          }}
          minutes · {{ leg.distance_miles }} miles
        </dd>
      </div>
    </dl>
  </div>
</template>
